import React, { useState, useEffect } from 'react';

function NavigationHeader({ onNavigate, isOpponentView = false, isGearView = false, isStandingsView = false }) {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Responsive breakpoints
    const isMobile = screenWidth < 768;
    const isTablet = screenWidth >= 768 && screenWidth < 1024;
    const isDesktop = screenWidth >= 1024;

    const headerStyle = {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        backgroundColor: '#2E86C1',
        padding: '0',
        margin: '0 auto 20px auto',
        minHeight: isMobile ? '50px' : '60px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        maxWidth: '800px', // Match the content width from TeamPage
        width: '100%'
    };

    const getButtonWidth = () => {
        if (isMobile) return '100px';
        if (isTablet) return '140px';
        return '180px'; // Desktop
    };

    const getFontSize = () => {
        if (isMobile) return '14px';
        return '16px';
    };

    const getPadding = () => {
        if (isMobile) return '12px 20px';
        return '15px 30px';
    };

    const baseButtonStyle = {
        padding: getPadding(),
        margin: '0',
        backgroundColor: '#3498DB',
        color: 'white',
        border: 'none',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: getFontSize(),
        textTransform: 'uppercase',
        letterSpacing: isMobile ? '0.5px' : '1px',
        transition: 'all 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '1', // TEAM and GEAR split remaining space equally
        borderRight: '1px solid rgba(255,255,255,0.2)'
    };

    const homeButtonStyle = {
        ...baseButtonStyle,
        backgroundColor: '#8E44AD',
        position: 'relative',
        paddingLeft: isMobile ? '25px' : '30px',
        width: isMobile ? '80px' : '100px', // HOME button is smaller and fixed width
        minWidth: isMobile ? '80px' : '100px',
        maxWidth: isMobile ? '80px' : '100px',
        flex: 'none' // HOME button stays fixed size
    };

    const arrowStyle = {
        position: 'absolute',
        left: isMobile ? '8px' : '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '0',
        height: '0',
        borderTop: isMobile ? '5px solid transparent' : '6px solid transparent',
        borderBottom: isMobile ? '5px solid transparent' : '6px solid transparent',
        borderRight: isMobile ? '8px solid white' : '10px solid white'
    };

    const buttonHoverStyle = {
        backgroundColor: '#5DADE2'
    };

    const homeButtonHoverStyle = {
        backgroundColor: '#A569BD'
    };

    return (
        <div style={headerStyle}>
            {isOpponentView ? (
                // Opponent view navigation - NO GEAR BUTTON
                <>
                    <button
                        style={baseButtonStyle}
                        onClick={() => onNavigate('LEAGUE')}
                        onMouseEnter={(e) => e.target.style.backgroundColor = buttonHoverStyle.backgroundColor}
                        onMouseLeave={(e) => e.target.style.backgroundColor = baseButtonStyle.backgroundColor}
                    >
                        STANDINGS
                    </button>
                    
                    <button
                        style={{...baseButtonStyle, borderRight: 'none'}}
                        onClick={() => onNavigate('TEAM')}
                        onMouseEnter={(e) => e.target.style.backgroundColor = buttonHoverStyle.backgroundColor}
                        onMouseLeave={(e) => e.target.style.backgroundColor = baseButtonStyle.backgroundColor}
                    >
                        TEAM
                    </button>
                </>
            ) : isGearView ? (
                // Gear view navigation - HOME, TEAM, LEAGUE
                <>
                    <button
                        style={homeButtonStyle}
                        onClick={() => onNavigate('HOME')}
                        onMouseEnter={(e) => e.target.style.backgroundColor = homeButtonHoverStyle.backgroundColor}
                        onMouseLeave={(e) => e.target.style.backgroundColor = homeButtonStyle.backgroundColor}
                    >
                        LEAGUES
                    </button>
                    
                    <button
                        style={baseButtonStyle}
                        onClick={() => onNavigate('TEAM')}
                        onMouseEnter={(e) => e.target.style.backgroundColor = buttonHoverStyle.backgroundColor}
                        onMouseLeave={(e) => e.target.style.backgroundColor = baseButtonStyle.backgroundColor}
                    >
                        TEAM
                    </button>
                    
                    <button
                        style={{...baseButtonStyle, borderRight: 'none'}}
                        onClick={() => onNavigate('LEAGUE')}
                        onMouseEnter={(e) => e.target.style.backgroundColor = buttonHoverStyle.backgroundColor}
                        onMouseLeave={(e) => e.target.style.backgroundColor = baseButtonStyle.backgroundColor}
                    >
                        STANDINGS
                    </button>
                </>
            ) : isStandingsView ? (
                // Standings view navigation - HOME, TEAM, GEAR (no LEAGUE since already on league page)
                <>
                    <button
                        style={homeButtonStyle}
                        onClick={() => onNavigate('HOME')}
                        onMouseEnter={(e) => e.target.style.backgroundColor = homeButtonHoverStyle.backgroundColor}
                        onMouseLeave={(e) => e.target.style.backgroundColor = homeButtonStyle.backgroundColor}
                    >
                        LEAGUES
                    </button>
                    
                    <button
                        style={baseButtonStyle}
                        onClick={() => onNavigate('TEAM')}
                        onMouseEnter={(e) => e.target.style.backgroundColor = buttonHoverStyle.backgroundColor}
                        onMouseLeave={(e) => e.target.style.backgroundColor = baseButtonStyle.backgroundColor}
                    >
                        TEAM
                    </button>
                    
                    <button
                        style={{...baseButtonStyle, borderRight: 'none'}}
                        onClick={() => onNavigate('GEAR')}
                        onMouseEnter={(e) => e.target.style.backgroundColor = buttonHoverStyle.backgroundColor}
                        onMouseLeave={(e) => e.target.style.backgroundColor = baseButtonStyle.backgroundColor}
                    >
                        GEAR
                    </button>
                </>
            ) : (
                // Own team navigation - HOME, LEAGUE, GEAR
                <>
                    <button
                        style={homeButtonStyle}
                        onClick={() => onNavigate('HOME')}
                        onMouseEnter={(e) => e.target.style.backgroundColor = homeButtonHoverStyle.backgroundColor}
                        onMouseLeave={(e) => e.target.style.backgroundColor = homeButtonStyle.backgroundColor}
                    >
                        LEAGUES
                    </button>
                    
                    <button
                        style={baseButtonStyle}
                        onClick={() => onNavigate('LEAGUE')}
                        onMouseEnter={(e) => e.target.style.backgroundColor = buttonHoverStyle.backgroundColor}
                        onMouseLeave={(e) => e.target.style.backgroundColor = baseButtonStyle.backgroundColor}
                    >
                        STANDINGS
                    </button>
                    
                    <button
                        style={{...baseButtonStyle, borderRight: 'none'}}
                        onClick={() => onNavigate('GEAR')}
                        onMouseEnter={(e) => e.target.style.backgroundColor = buttonHoverStyle.backgroundColor}
                        onMouseLeave={(e) => e.target.style.backgroundColor = baseButtonStyle.backgroundColor}
                    >
                        GEAR
                    </button>
                </>
            )}
        </div>
    );
}

export default NavigationHeader;